export const parseVertexCredentialV814 = (value = '') => {
  const jsonStart = value.indexOf('{');
  if (jsonStart < 0) throw new Error('Vertex AI credential must be JSON.');
  const parsed = JSON.parse(value.slice(jsonStart));
  const legacyPrefix = value.slice(0, jsonStart).trim().replace(/\|$/, '');
  const legacyParts = legacyPrefix.split('|');
  const legacyProjectId =
    legacyParts.length >= 2 ? String(legacyParts[1]).trim() : '';
  const projectId = String(
    parsed.project_id || parsed.quota_project_id || legacyProjectId
  ).trim();
  if (!projectId) {
    throw new Error('Vertex AI credential JSON must contain project_id.');
  }
  if (!parsed.project_id && !parsed.quota_project_id && legacyProjectId) {
    parsed.project_id = legacyProjectId;
  }
  return { projectId, keyValue: JSON.stringify(parsed) };
};
